import { Injectable, inject } from '@angular/core';

import { BaseSignalQuery } from '../signal-state.util';

import { CurrentProjectState, CurrentProjectStore } from './current-project.store';

@Injectable({ providedIn: 'root' })
export class CurrentProjectQuery extends BaseSignalQuery<CurrentProjectState> {
  constructor() {
    const store = inject(CurrentProjectStore);
    super(store);
  }
}
